import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Handle, Position} from "react-flow-renderer";
import Select from 'react-select';
import {isVisible} from "@testing-library/user-event/dist/utils";





const customStyles = {
    option: (provided, state) => ({
        ...provided,
        // borderBottom: '1px dotted pink',
        color: state.isSelected ? 'white' : 'black',
        padding: 7,


    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        //  width: 150,
        display: "flex",
        flexDirection: "row",
        textAlign: 'left',

    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        const color = "rgb(255, 255, 255,90%)";
        return {...provided, opacity, transition, color};
    }
}


const DataComponent = ({data, nodeId, index, isVis, type}) => {
    // const onChange = useCallback((evt) => {
    //
    // }, []);

    const theme = (theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: 'hotpink',
            primary: 'black',

        },
    })

    const [variables, setVariables] = useState([])
    const [opt1, setopt1] = useState('')
    const [opt3, setopt3] = useState('')
    const [opened, setOpened] = useState(false)


    useEffect(()=>{
        data.data[index].setIsOpen = setOpened;
    },[])

    useEffect(() => {
        const vars = JSON.parse(localStorage.getItem('variables'))

setOpened(false)




        if (vars !== null) {
            let qqe = []
            for (const vaer of vars) {
                qqe.push({value: vaer.name, label: `${vaer.name} (${vaer.type})`, type: vaer.type})
            }
            setVariables(qqe)
        }

        setopt1({
            value: data.data[index].name,
            label: `${data.data[index].name} (${data.data[index].type})`,
            type: data.data[index].type
        })
        setopt3(data.data[index].value)


    }, [isVis])



    const [textWidth, setTextWidth ] = useState("100px");

    useEffect(()=>{


            if(data.textAreaRef != null){

                setTextWidth(`${data.textAreaRef.style.width.match(/\d+/)[0]-5}px`)
            }

    },[data.textAreaRef.style.width])


    return (

        <div
            // onMouseEnter={()=>{setOnHover(true)}}
            // onMouseLeave={()=>{setOnHover(false)}}
            onMouseUp={()=>{
                data.data.forEach((value)=>{value.setIsOpen(false)})
                setOpened(true)
            }}

           // onDoubleClick={onDoubleClick}
            className="If-node"
        style={{
            cursor:"pointer"
           // display:"flex",
            //flexDirection:"row"
            }}>


            { !opened &&
                <div style={{
                    fontStyle: "italic",
                    width:textWidth,
                    height:"26px",
                    maxWidth:"500px",
                    whiteSpace:"nowrap",
                    overflow:"hidden",
                    textOverflow:"ellipsis"
                }}>{`${opt1.label}: ${opt3}`}</div>
            }


            {isVis && opened &&
                <Select
                    options={variables}

                    theme={theme}

                    styles={customStyles}
                    className="selectReact"
                    value={opt1}
                    // defaultValue={data.value_1}
                    onChange={(e) => {
                        setopt1(e)
                        data.data[index].name = e.value
                        data.data[index].type = e.type
                    }}
                />
            }


            {isVis && opened &&
                <input style={{background: "white", outline: "0", border: "0", padding: "6px",
                  width:"auto"
                }}
                       value={opt3}
                       defaultValue={data.value_2}
                       onChange={(e) => {
                           setopt3(e.target.value)
                           data.data[index].value = e.target.value
                       }}/>
            }



        </div>
    );
};

export default DataComponent